// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class MergeSetting extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  mergeSettingId!: number;
  createdBy!: string;
  createdDate!: Date;
  setting!: string;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
}

